import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/InputField/SelectField';
import DateRangeField from 'components/InputField/DateRangeField';

const labels = {
  date_from: 'Starts from',
  date_to: 'To',
};

function Filters({
  onDateRangeChange,
  onChangeQuery,
  query
}) {
  return (
    <div className="container_admin_user">
      <DateRangeField
        onChange={onDateRangeChange}
        fromValue={query.date_from}
        toValue={query.date_to}
        fieldName={'date'}
        className="calendar_picker"
        labels={labels}
      />
      <div className='col s4 search_admin'>
        <input id="search" type="submit" className="validate" />
        <label htmlFor="search">
          <i className="material-icons icon_search">search</i>
        </label>
        <input
          type="search"
          placeholder="Search"
          value={query.title}
          onChange={(e) => onChangeQuery('title', e.target.value)} />
            <i onClick={(e) => onChangeQuery('title', '')} className="material-icons icon_close">close</i>
      </div>
    </div>
  );
}

Filters.defaultProps = {};

Filters.propTypes = {};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Webinar/Toolbar/Filters.jsx